import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { IInvoice, defaultValue } from 'app/shared/model/invoice.model';
import { IQueryParams, serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState = {
  loading: false,
  errorMessage: null,
  invoices: [] as ReadonlyArray<IInvoice>,
  authorities: [] as any[],
  invoice: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};
const apiUrl = 'api/invoices';

export const getInvoices = createAsyncThunk('invoice/fetch_invoices', async ({ page, size, sort, organisation }: IQueryParams) => {
  const requestUrl = `${apiUrl}${`?organisationId=${organisation}&`}${sort ? `page=${page}&size=${size}&sort=${sort}` : ''}`;
  return axios.get<IInvoice[]>(requestUrl);
});

export type InvoiceState = Readonly<typeof initialState>;

export const InvoiceSlice = createSlice({
  name: 'invoice',
  initialState: initialState as InvoiceState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(isFulfilled(getInvoices), (state, action) => {
      state.loading = false;
      state.invoices = action.payload.data;
      state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
    });
  },
});

export const { reset } = InvoiceSlice.actions;

// Reducer
export default InvoiceSlice.reducer;
